import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

export const useDialog = () => {
    const navigate = useNavigate()

    const [config, setConfig] = useState({open: false, title: null, backUrl: null, fullScreen: false, fullWidth: false})

    const open = (title = '', backUrl = null, maxWidth = 'sm', fullWidth = false, fullScreen = false) => {
        setConfig(prevConfig => ({ ...prevConfig, open: true, title: title, backUrl: backUrl, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen }))
    }

    const close = () => {
        setConfig(prevConfig => ({ ...prevConfig, open: false }))
    }

    const onClose = () => {
        if (config.backUrl === 'closeOnly') return close()
        if (!config.backUrl) window.history.back()
        else navigate(config.backUrl)
    }

    return { config, open, close, onClose }
}